import type { FormValues } from "@/widgets/classic-form/form";
import type { OtherFieldGroup } from "@/entities/form-metadata";

export const populateOtherFields = ({
    fieldGroup,
    dataModel,
    formValuesFieldsData,
    matchAllTermsExactly,
}: {
    fieldGroup: OtherFieldGroup;
    dataModel: FormValues;
    formValuesFieldsData: FormValues["fields"];
    matchAllTermsExactly: boolean;
}) => {
    const { fields: fieldsFromDataModel } = dataModel;

    fieldGroup.others.forEach((otherItem) => {
        const { relation, assertion, eventType: eventName, fields } = otherItem;
        const fieldAccessor = `${relation}${eventName}${assertion}`;
        // @ts-ignore FIXME
        const isExactnessEnabled = fields[0].features.showExactness ?? true;

        const isExactEnabledValue = matchAllTermsExactly
            ? true
            : (fieldsFromDataModel[fieldAccessor]?.isExact ?? false);

        formValuesFieldsData[fieldAccessor] = {
            value: fieldsFromDataModel[fieldAccessor]?.value ?? "",
            relation,
            eventName,
            assertion,
            isExact: isExactnessEnabled ? isExactEnabledValue : false,
        };
    });
};
